import { render, staticRenderFns } from "./IndexAppStatistics.vue?vue&type=template&id=cf7c7d44&scoped=true"
import script from "./IndexAppStatistics.vue?vue&type=script&lang=js"
export * from "./IndexAppStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7c7d44",
  null
  
)

export default component.exports